import axios, { type AxiosResponse } from 'axios'

import type {
    PersonalPickupsListResponse,
    PersonalPickupDetailResponse,
    CreatePersonalPickupRequest,
    CreatePersonalPickupForPackageRequest,
    UpdatePersonalPickupRequest,
    PersonalPickupOrdersListResponse,
    PersonalPickupPackagesListResponse
} from '@/api/schemas/shipments/personalPickups'
import { API_ENDPOINTS } from '@/constants'

class PersonalPickupsQueries {
    fetchPersonalPickups(queryString = ''): Promise<AxiosResponse<PersonalPickupsListResponse>> {
        const url = `${API_ENDPOINTS.PERSONAL_PICKUPS.LIST}${queryString ? `?${queryString}` : ''}`
        return axios.get<PersonalPickupsListResponse>(url)
    }

    fetchPersonalPickup(id: number): Promise<AxiosResponse<PersonalPickupDetailResponse>> {
        return axios.get<PersonalPickupDetailResponse>(`${API_ENDPOINTS.PERSONAL_PICKUPS.DETAIL}/${id}`)
    }

    createPersonalPickup(payload: CreatePersonalPickupRequest): Promise<AxiosResponse<PersonalPickupDetailResponse>> {
        return axios.post<PersonalPickupDetailResponse>(API_ENDPOINTS.PERSONAL_PICKUPS.CREATE_PERSONAL_PICKUP, payload)
    }

    createPersonalPickupForPackage(
        payload: CreatePersonalPickupForPackageRequest
    ): Promise<AxiosResponse<PersonalPickupDetailResponse>> {
        return axios.post<PersonalPickupDetailResponse>(
            API_ENDPOINTS.PERSONAL_PICKUPS.CREATE_PERSONAL_PICKUP_FOR_PACKAGE,
            payload
        )
    }

    updatePersonalPickup(id: number, payload: UpdatePersonalPickupRequest): Promise<AxiosResponse<PersonalPickupDetailResponse>> {
        return axios.put<PersonalPickupDetailResponse>(`${API_ENDPOINTS.PERSONAL_PICKUPS.DETAIL}/${id}`, payload)
    }

    deletePersonalPickup(id: number): Promise<AxiosResponse<void>> {
        return axios.delete<void>(`${API_ENDPOINTS.PERSONAL_PICKUPS.DETAIL}/${id}`)
    }

    fetchPersonalPickupsOrders(queryString = ''): Promise<AxiosResponse<PersonalPickupOrdersListResponse>> {
        const url = `${API_ENDPOINTS.PERSONAL_PICKUPS.ORDERS}${queryString ? `?${queryString}` : ''}`
        return axios.get<PersonalPickupOrdersListResponse>(url)
    }

    fetchPackages(queryString = ''): Promise<AxiosResponse<PersonalPickupPackagesListResponse>> {
        const url = `${API_ENDPOINTS.PERSONAL_PICKUPS.PACKAGES}${queryString ? `?${queryString}` : ''}`
        return axios.get<PersonalPickupPackagesListResponse>(url)
    }
}

export default new PersonalPickupsQueries()
